<script setup lang="ts">
	import Credit from "~/components/forms/Credit.vue";
	import CreditAlt from "~/components/forms/CreditAlt.vue";
	import StepCards from "~/components/static/StepCards.vue";
	import Header from "../components/ui/Header.vue";

	const { locale: formLocale } = await useLocale("forms", null, true);
	const { locale: homeLocale } = await useLocale("ui", null, true);

	const emit = defineEmits(["submit"]);

	const iconsCredit = computed(() => [
		{
			text: formLocale.value?.credit.icons.phone.text,
			icon: "Phone-blue2",
		},
		{
			text: formLocale.value?.credit.icons.rata.text,
			icon: "RataFissa-blue2",
		},
		{
			text: formLocale.value?.credit.icons.flash.text,
			icon: "Flash-blue2",
		},
	]);

	const iconComponents = computed(() => {
		return iconsCredit.value.map((icon) => iconComponent(icon));
	});

	const creditForm: Component = useTemplateRef('credit-form');

	const focusCreditSelect = () => {
	window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	setTimeout(() => {
		creditForm.value?.focusSelect();
	}, 400);
	};


</script>

<template>
  	<div class="bg-[#F0F0F0] -mt-[1px] cherrybank-home">
		<Header>
			<img src="@/themes/cherrybank/assets/img/logo-cofidis-cherrybank.svg" alt="Logo Cofidis e Cherry Bank" />
		</Header>
		<Credit
		    ref="credit-form"
			class="relative z-30 mt-12 mb-10"
			:values="getCreditValues()"
			:cta-text="formLocale?.credit.labels.submit"
			:cta-subtext="formLocale?.credit.labels.ctaSubmit"
			@submit="emit('submit')"
		>
			<template #title>
				<span v-html="formLocale?.credit.title"></span>
			</template>
			<template #text>
				<span v-html="formLocale?.credit.subtitle"></span>
			</template>
			<template #icons>
				<div class="grid grid-cols-3 py-4 sm:py-4 lg:px-40">
					<div 
						v-for="icon in iconComponents"
						:key="icon.text"
						class="text-center my-4"
					>
						<component
							:is="icon.icon"
							class="align-middle w-10 h-10 block rounded-full mb-1 sm:mt-0 inline-block"
						>
						</component>
						<p class="text-gray-5 text-sm lg:px-2" v-html="icon.text" />
					</div>
				</div>
			</template>
		</Credit>

		<p class="text-center w-full mb-5 text-[--slate-blue] px-6" v-html="homeLocale?.home.helper_text" />

		<p class="text-center w-full mb-10 text-[--slate-blue] px-6 text-sm" v-html="homeLocale?.home.disclaimer" />

		<StepCards
			:cta="homeLocale?.home.section_steps.button_text"
			:steps="homeLocale?.home.section_steps.steps"
			@click="focusCreditSelect"
		>
			<template #title>
				<span>{{ homeLocale?.home.section_steps.title }}</span>
			</template>
		</StepCards>

		<CreditAlt
			:cta-text="formLocale?.credit_alt.button.submit"
			:cta-subtext="formLocale?.credit_alt.button.ctaSubmit"
			:values="getCreditValues()"
			@submit="emit('submit')"
		>
			<template #title>
				<span class="text-3xl">{{ formLocale?.credit_alt.title }}</span>
			</template>
			<template #text>
				<span>{{ formLocale?.credit_alt.subtitle }}</span>
			</template>
			<template #helper_text>
				<span>{{ formLocale?.credit_alt.helper_text }}</span>
			</template>
		</CreditAlt>
		<div class="spacer h-6" />
	</div>
</template>
